import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
`
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 1152px;
    width: 100%;
`

export const Title = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 550px;
    min-height: 550px;
    width: 100%;
    background: #059033;
`

export const TitleImage = styled.image`
    max-width: 1152px;
    max-height: 880px;
`

export const H1 = styled.h1`
    font-size: 5.8rem;
    font-family: Helvetica;
    color: #d4eeb8;
    height: 200px;
    margin: 75px 0px 25px 75px;
`

export const H2 = styled.h2`

`

export const P = styled.p`
    display: flex;
    justify-content: flex-start;
    color: #93cb56;
    font-size: 2rem;
    height: 275px;
    margin: 20px 0px 0px 125px;
`

export const Features = styled.div`
    display: flex;
    align-items: center;
    height: 180px;
    background: #059033;
    padding: 0px 0px 0px 75px;
    font-size: 1.5rem;
    font-family: Helvetica;
    color: #d4eeb8;
`

export const FeaturesContent = styled.div`
    height: 500px;
`

export const FeaturesContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
`

export const FeaturesContentTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 180px;
    font-size: 1.3rem;
`

export const LeftRightWrapper = styled.div`
    display: flex;
    height: 320px;
    justify-content: space-between;
    
`

export const LeftWrapper = styled.div`
    padding-left: 250px;
`

export const LeftWrapperDiv = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.5rem;
`

export const LeftWrapperSpan = styled.div`
    margin-right: 25px;
    font-size: 3rem;
`

export const RightWrapper = styled.div`
    padding-right: 250px;
`

export const RightWrapperDiv = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.5rem;
`

export const RightWrapperSpan = styled.div`
    margin-right: 25px;
    font-size: 3rem;
`

export const SignUp = styled.div`
    display: flex;
    align-items: center;
    height: 180px;
    background: #059033;
    padding: 0px 0px 0px 75px;
    font-size: 1.5rem;
    font-family: Helvetica;
    color: #d4eeb8;
`